module.exports = __webpack_public_path__ + "img/hair_back_female_wavy_short_mask.ec9301fb.png";